const CONTENTFUL_IMAGE_API_BASE_URL = '//images.ctfassets.net';
export const DEFAULT_API_OPTIONS: ContentfulImageApiOptions = { fm: 'webp', f: 'top', fit: 'fill' };

export type ContentfulImageApiOptions = {
  w?: number; // Width -- specify an image width
  h?: number; // Height -- specify an image height
  fm?: 'jpg' | 'png' | 'webp' | 'gif' | 'avif'; // Format -- Convert to a specific image format.
  fl?: 'progressive' | 'png8'; // Sub-format -- Progressive JPEG or 8 bit png
  fit?: 'pad' | 'fill' | 'scale' | 'crop' | 'thumb'; // Fit -- how the image should be resized to fit the specified dimensions
  f?:
    | 'center'
    | 'top'
    | 'right'
    | 'left'
    | 'bottom'
    | 'top_right'
    | 'top_left'
    | 'bottom_right'
    | 'bottom_left'
    | 'face'
    | 'faces'; // Focus -- choose the focus area when resizing
  r?: number | 'max'; // Crop radius -- crop the image into a circle or ellipse
  q?: number; // Quality -- image quality between 1-100. Ignored for subFormat:png8
  bg?: string; //Background color -- color to use when using corner radius or pad. Format: rgb:RRGGBB
};

export const buildContentfulApiImgSrc = (src: string, apiOptions: ContentfulImageApiOptions = DEFAULT_API_OPTIONS) => {
  if (!src?.includes(CONTENTFUL_IMAGE_API_BASE_URL)) {
    return src;
  }
  const imageUrl = new URL(src.startsWith('https') ? src : `https:${src}`);
  Object.entries(apiOptions).forEach(([key, value]) => Boolean(value) && imageUrl.searchParams.set(key, `${value}`));
  return imageUrl.toString();
};
